import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SegmentedTabs } from "@akuna/ui";
import { useHasPermissionSync } from "@/hooks/usePermissions";

const SECTION_PATHS = { items: "/catalog", commissions: "/catalog/commissions" } as const;

export function CatalogSectionNav({ active }: { active: "items" | "commissions" }) {
  const { t } = useTranslation("commissions");
  const navigate = useNavigate();
  const { hasPermission: canSeeCommissions } = useHasPermissionSync("commissions", "view");
  if (!canSeeCommissions) return null;
  return (
    <div className="w-full md:w-fit">
      <SegmentedTabs
        className="w-full"
        variant="outline"
        value={active}
        onValueChange={(value) => navigate(SECTION_PATHS[value as keyof typeof SECTION_PATHS])}
        items={[
          { value: "items", label: t("catalog.sectionNav.items") },
          { value: "commissions", label: t("catalog.sectionNav.commissions") },
        ]}
      />
    </div>
  );
}
